import { render, staticRenderFns } from "./follow-button.vue?vue&type=template&id=5d263246&"
import script from "./follow-button.vue?vue&type=script&lang=ts&"
export * from "./follow-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d263246')) {
      api.createRecord('5d263246', component.options)
    } else {
      api.reload('5d263246', component.options)
    }
    module.hot.accept("./follow-button.vue?vue&type=template&id=5d263246&", function () {
      api.rerender('5d263246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/forms/follow-button.vue"
export default component.exports